<template>
  <div class="careers-internships">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="text-group">
        <h3 class="text-accent">{{ $t("careers-internships-1") }}</h3>
        <h1>{{ $t("careers-internships-2") }}</h1>
        <h2>{{ $t("careers-internships-3") }}</h2>
      </div>
    </div>

    <!-- ITEM 1 -->

    <div class="careers-internship-items">
      <div
        class="careers-internship-item"
        :class="{ 'careers-internship-item-active': active[0] }"
      >
        <div class="careers-internship-item-top">
          <div
            class="item-img"
            :style="{
              backgroundImage: `url(${require('../../assets/img/careers/internships/1.png')})`,
            }"
            @click="toggleItem(0)"
          ></div>
          <div class="text-group">
            <!-- <h3 class="text-light">{{ $t("careers-internships-12") }}</h3> -->
            <h1 class="text-light">{{ $t("careers-internships-13") }}</h1>
            <!-- <h1 class="text-light">{{ $t("careers-internships-14a") }}</h1> -->
          </div>
        </div>
        <div class="text-group">
          <p>
            <strong>{{ $t("careers-internships-14") }}</strong>
            <br />
            {{ $t("careers-internships-14-0") }}
          </p>
          <p>{{ $t("careers-internships-14-1") }}</p>
          <a
            href="/files/careers/stipendia-terms.pdf"
            target="_blank"
            class="link"
          >
            <span class="text-main-home">{{
              $t("careers-internships-15")
            }}</span>
          </a>
          <br />
          <br />
          <a
            href="/files/careers/stipendia-form.pdf"
            target="_blank"
            class="link"
          >
            <span class="text-main-home">{{
              $t("careers-internships-15-1")
            }}</span>
          </a>
        </div>
      </div>

      <!-- ITEM 2 -->

      <div
        class="careers-internship-item"
        :class="{ 'careers-internship-item-active': active[1] }"
      >
        <div class="careers-internship-item-top">
          <div
            class="item-img"
            :style="{
              backgroundImage: `url(${require('../../assets/img/careers/internships/2.jpg')})`,
            }"
            @click="toggleItem(1)"
          ></div>
          <div class="text-group">
            <!-- <h3 class="text-light">{{ $t("careers-internships-8") }}</h3> -->
            <h1 class="text-light">{{ $t("careers-internships-9") }}</h1>
          </div>
        </div>
        <div class="text-group">
          <p>{{ $t("careers-internships-10") }}</p>
          <a
            href="/files/careers/internship-development.pdf"
            target="_blank"
            class="link"
          >
            <span class="text-main-home">{{
              $t("careers-internships-11a")
            }}</span>
          </a>
          <br />
          <br />
          <a
            href="/files/careers/internship-support.pdf"
            target="_blank"
            class="link"
          >
            <span class="text-main-home">{{
              $t("careers-internships-11b")
            }}</span>
          </a>
        </div>
      </div>

      <!-- ITEM 3 -->

      <div
        class="careers-internship-item"
        :class="{ 'careers-internship-item-active': active[2] }"
      >
        <div class="careers-internship-item-top">
          <div
            class="item-img"
            :style="{
              backgroundImage: `url(${require('../../assets/img/careers/internships/3.jpg')})`,
            }"
            @click="toggleItem(2)"
          ></div>
          <div class="text-group">
            <!-- <h3 class="text-light">{{ $t("careers-internships-4") }}</h3> -->
            <h1 class="text-light">{{ $t("careers-internships-5") }}</h1>
          </div>
        </div>
        <div class="text-group">
          <p>{{ $t("careers-internships-6") }}</p>
          <router-link to="/careers?page=internships" class="link">
            <!-- <span class="text-main-home">{{ $t('careers-internships-7') }}</span> -->
          </router-link>
        </div>
      </div>

      <!-- ITEM 4 -->

      <div
        class="careers-internship-item"
        :class="{ 'careers-internship-item-active': active[3] }"
      >
        <div class="careers-internship-item-top">
          <div
            class="item-img"
            :style="{
              backgroundImage: `url(${require('../../assets/img/careers/internships/4.jpg')})`,
            }"
            @click="toggleItem(3)"
          ></div>
          <div class="text-group">
            <!-- <h3 class="text-light">{{ $t("careers-internships-16") }}</h3> -->
            <h1 class="text-light">{{ $t("careers-internships-17") }}</h1>
          </div>
        </div>
        <div class="text-group">
          <!-- <p>{{ $t("careers-internships-18") }}</p> -->
          <p></p>
          <a @click.prevent="isVideoOpened = true" class="link text-main-home">
            <span class="text-main-home">{{
              $t("careers-internships-19")
            }}</span>
          </a>
        </div>
      </div>
    </div>
    <Apply />
    <transition name="fade">
      <MediaModal v-if="isVideoOpened" :media="video" />
    </transition>
  </div>
</template>

<script>
import Apply from "./shared/Apply";
export default {
  components: {
    Apply,
    MediaModal: () => import("../shared/MediaModal.vue"),
  },
  data() {
    return {
      active: [false, false, false, false],
      isVideoOpened: false,
      video: {
        type: "pdf",
        url: 'https://heyzine.com/flip-book/c39d05d0d3.html',
        // url: require("../../../files/careers/old/KCM_Brochure_148x105mm_16pg.pdf"),
        // type: "video",
        // url: require("../../assets/video/careers/internships.mp4"),
      },
    };
  },
  methods: {
    scroll(n) {
      const active = document.getElementsByClassName("careers-internship-item")[
        n
      ];
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: active.getBoundingClientRect().top + scrollTop,
        behavior: "smooth",
      });
    },
    toggleItem(n) {
      this.$set(this.active, n, !this.active[n]);

      document.body.style.overflow = this.active[n] ? "hidden" : "";

      if (this.active[n]) {
        this.scroll(n);

        // scroll once again just in case if for example header is not small yet

        setTimeout(() => {
          this.scroll(n);
        }, 1000);

        document.addEventListener("keyup", this.handleScroll);
      }
    },
    handleScroll(e) {
      if (e.keyCode === 27) {
        document.removeEventListener("keyup", this.handleScroll);
        this.active = [false, false, false, false];
        document.body.style.overflow = "";
      }
    },
  },
  mounted() {
    this.$on("close-media-modal", () => {
      this.isVideoOpened = false;
    });
  },
  destroyed() {
    this.$off("close-media-modal");
  },
};
</script>

<style lang="scss" scoped>
.careers-internships {
  position: relative;
  .row-1 {
    padding-left: $sidesPadding;
    padding-right: $sidesPadding;
    .text-group {
      width: 50%;
    }
  }
  .careers-internship-items {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    .careers-internship-item {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-left: 2%;
      margin-right: 4%;
      padding: 39vw 1vw 40px 6vw;
      position: relative;
      @include transition(all 0.6s $mainCubic);
      width: 44%;
      z-index: 1;
      .careers-internship-item-top {
        position: absolute;
        left: 3vw;
        width: 40vw;
        top: 5vw;
        height: 34vw;
        @include transition(all 0.6s $mainCubic);
        z-index: 1;
        .item-img {
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          // IE
          cursor: pointer;
          cursor: zoom-in;
          display: block;
          left: $sidesPadding / 4;
          position: relative;
          margin: 0 auto;
          height: 88%;
          top: -10%;
          @include transition(all 0.6s $mainCubic);
          width: 105%;
        }
        .text-group {
          display: flex;
          flex-direction: column;
          height: 17%;
          justify-content: center;
          padding-left: 3vw;
          padding-right: 1rem;
          position: relative;
          @include transition(all 0.6s $mainCubic);
          top: -10%;
          width: 100%;

          h3 {
            margin: 0 0 5px;
          }

          h1 {
            line-height: 30px;
          }
        }
      }
      > .text-group {
        @include transition(all 0.6s $mainCubic);
      }
    }
    .careers-internship-item:nth-child(even) {
      top: -5vw;
    }
    .careers-internship-item:nth-child(2) {
      background-color: #fffbde;
      margin-bottom: 5vw;
      margin-left: 1%;
      margin-right: 3%;
      width: 46%;
      .careers-internship-item-top {
        background-color: #e7ba2e;
        left: 4vw;
      }
    }
    .careers-internship-item:nth-child(1) {
      background-color: #e8e0d8;
      margin-right: 2%;
      padding-right: 3%;
      margin-bottom: 5vw;
      width: 46%;
      .careers-internship-item-top {
        background-color: #cc9e6b;
        .text-group {
          h1 {
            font-size: 30px;
            line-height: 30px;
          }
        }
      }
      // IT'S HERE BECAUSE IF IT'S IN THE SCOPE ABOVE IT'S GOING TO BE OVERWRITTEN
      .item-img {
        // height: 90%;
        width: 100%;
      }
    }
    .careers-internship-item:nth-child(3) {
      background-color: #fce5e5;
      .careers-internship-item-top {
        background-color: #b73940;
      }
    }
    .careers-internship-item:nth-child(4) {
      background-color: #dceaef;
      .careers-internship-item-top {
        background-color: #1795d0;
        .item-img {
          width: 101%;
        }
        // .text-group {
        //   height: 20%;
        // }
      }
      .careers-internship-item-top::after {
        background-color: #1795d0;
        content: "";
        height: 100%;
        top: 0;
        position: absolute;
        left: 100%;
        width: 4vw;
        z-index: -1;
      }
    }
    .careers-internship-item-active {
      margin-left: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      z-index: 10;
      .careers-internship-item-top {
        height: 100vh;
        left: 0;
        padding: $sidesPadding / 2;
        position: absolute;
        top: 0;
        width: 100vw;
        z-index: 10;
        .item-img {
          // IE
          cursor: pointer;
          cursor: zoom-out;
          height: 100%;
          left: 0;
          top: 0;
          width: 100%;
        }
        .text-group {
          top: 0;
          margin: 0;
          opacity: 0;
        }
      }
      > .text-group {
        opacity: 0;
      }
    }
    .careers-internship-item-active:nth-child(even) {
      .careers-internship-item-top {
        left: -50vw;
      }
    }
  }
}
@media screen and (max-width: 1640px) {
  .careers-internships
    .careers-internship-items
    .careers-internship-item:nth-child(1)
    .careers-internship-item-top
    .text-group
    h1 {
    font-size: 26px;
    line-height: 26px;
  }
}

@media screen and (max-width: 1600px) {
  .careers-internships {
    .row-1 {
      padding-left: $sidesPadding1600;
      padding-right: $sidesPadding1600;
    }
  }
}
@media screen and (max-width: 1440px) {
  .careers-internships
    .careers-internship-items
    .careers-internship-item:nth-child(1)
    .careers-internship-item-top
    .text-group
    h1 {
    font-size: 22px;
    line-height: 22px;
  }
}

@media screen and (max-width: 1280px) {
  .careers-internships {
    .row-1 {
      padding-left: $sidesPadding1280;
      padding-right: $sidesPadding1280;
    }
    .careers-internship-items {
      .careers-internship-item {
        .careers-internship-item-top {
          width: 39vw;
          .text-group {
            h1 {
              font-size: 20px;
              line-height: 22px;
            }
            h3 {
              font-size: 10px;
            }
          }
          h4 {
            font-size: 14px;
            line-height: 22px;
          }
        }
      }
      .careers-internship-item:nth-child(1)
        .careers-internship-item-top
        .text-group
        h1 {
        font-size: 17px;
        line-height: 17px;
      }
      .careers-internship-item-active {
        .careers-internship-item-top {
          width: 100vw;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .careers-internships {
    .row-1 {
      padding: $sidesPadding1280;
      .text-group {
        width: 100%;
      }
    }
    .careers-internship-items {
      .careers-internship-item:nth-child(1n) {
        margin-left: $sidesPadding1280;
        margin-right: $sidesPadding1280;
        padding-left: $sidesPadding1280;
        padding-right: $sidesPadding1280;
        margin-bottom: 5vw;
        @include transform(initial);
        width: 100%;
        .careers-internship-item-top {
          left: 20px;
          width: calc(100% - 40px);
          .item-img {
            left: 0;
            top: -11%;
            width: 100%;
          }
          .text-group {
            padding: 0 20px;
          }
          h1 {
            font-size: 20px;
            line-height: 22px;
          }
          h3 {
            font-size: 10px;
          }
          h4 {
            font-size: 14px;
            line-height: 22px;
          }
        }
      }
      .careers-internship-item:nth-child(even) {
        top: 0;
      }
      .careers-internship-item:nth-child(1):not(.careers-internship-item-active) {
        padding-top: 43vw;
        .careers-internship-item-top {
          height: 38vw;

          .item-img {
            height: 80%;
          }

          .text-group {
            height: 28%;
          }
        }
      }
      .careers-internship-item:nth-child(4) {
        .careers-internship-item-top::after {
          display: none;
        }
      }
      .careers-internship-item-active:nth-child(1n) {
        .careers-internship-item-top {
          left: 0;
          width: 100vw;
          .item-img {
            top: 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .careers-internships {
    .row-1 {
      padding: $sidesPadding600;
    }
    .careers-internship-items {
      .careers-internship-item:nth-child(1n) {
        margin-left: $sidesPadding600;
        margin-right: $sidesPadding600;
        padding-left: $sidesPadding600;
        padding-right: $sidesPadding600;
        padding-top: 55vw;
        .careers-internship-item-top {
          height: 50vw;
          left: 20px;
          width: calc(100% - 40px);
          .item-img {
            top: -15%;
          }
          .text-group {
            h1 {
              font-size: 16px;
              line-height: 16px;
            }
            h3 {
              font-size: 9px;
            }
            h4 {
              font-size: 14px;
              line-height: 22px;
            }
          }
        }
      }

      .careers-internship-item:nth-child(1):not(.careers-internship-item-active) {
        padding-top: 66vw;
        .careers-internship-item-top {
          height: 56vw;

          .item-img {
            height: 77%;
          }
        }
      }
      .careers-internship-item-active:nth-child(1n) {
        .careers-internship-item-top {
          padding: 25px;
          height: 100vh;
          left: 0;
          width: 100vw;
          .item-img {
            top: 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 420px) {
  .careers-internships {
    .careers-internship-items {
      .careers-internship-item:nth-child(1n) {
        .careers-internship-item-top {
          left: 10px;
          width: calc(100% - 20px);
          .text-group {
            h1 {
              font-size: 13px;
              line-height: 13px;
            }
            h3 {
              font-size: 8px;
            }
          }
        }
      }
      .careers-internship-item-active:nth-child(1n) {
        .careers-internship-item-top {
          padding: 25px;
          height: 100vh;
          left: 0;
          width: 100vw;
          .item-img {
            top: 0;
          }
        }
      }
    }
  }
}
</style>
